import React from "react";
import { PDPMetadata, PDPMetadataProps } from "@vp/pdp-metadata";
import Helmet from "react-helmet";

export const MetadataWrapper: React.FC<PDPMetadataProps> = props => {
  const allProps = {
    ...props,
    renderWith: Helmet,
  };
  return <PDPMetadata {...allProps} />;
};
